import { Alert, Heading } from "@instructure/ui";
import { t } from "i18next";
import { useEffect, useState } from "react";
import DataGrid from "react-data-grid";
import Skeleton from "react-loading-skeleton";
import { useOutletContext } from "react-router-dom";
import { Selector } from "../../../../../components/Selectors/Selector";
import { AssignmentService } from "../../../../../services/AssignmentService";
import { buildAssignmentTable } from "../utils";

const CanvasAssignment = () => {
  const { setNextEnabled, assignments, setFormData, formData } =
    useOutletContext();
  const [selectedAssignmentId, setSelectedAssignmentId] = useState(
    formData.metadata?.assignmentId || ""
  );
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [rows, setRows] = useState([]);
  const [columns, setColumns] = useState([]);

  useEffect(() => {
    if (formData.metadata.results && "assignmentId" in formData.metadata) {
      const { outcomeColumns, studentRows } = buildAssignmentTable(
        formData.metadata.results
      );
      setColumns(outcomeColumns);
      setRows(studentRows);
    }
  }, [formData.metadata.results]); // eslint-disable-line

  async function handleSelectAssignment(assignmentId) {
    try {
      setLoading(true);
      setSelectedAssignmentId(assignmentId);
      const results = await AssignmentService.getResultsByContext(
        AssignmentService.ASSIGNMENT,
        assignmentId
      );
      setNextEnabled(true);
      setFormData((prev) => ({
        ...prev,
        metadata: {
          assignmentId: assignmentId,
          assignmentName: assignments.find((a) => a.id === assignmentId).name,
          results: results,
        },
      }));
    } catch {
      setError(true);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "0.75rem",
        height: "100%",
      }}
    >
      <Heading border="bottom" level="h3" as="h2" width="100%">
        {t("finalizeCourse.canvasAssignment")}
      </Heading>
      <Selector
        id="assignment-selector"
        label={t("assignment.assignment")}
        options={assignments}
        selectHandler={handleSelectAssignment}
        selectedItemId={selectedAssignmentId}
      />
      {loading ? (
        <div style={{ flex: "1" }}>
          <Skeleton height="100%" />
        </div>
      ) : rows.length > 0 && columns.length > 1 ? (
        <DataGrid
          className="rdg-light"
          style={{ flex: "1", marginBottom: "0.05rem" }}
          rowHeight={60}
          headerRowHeight={40}
          columns={columns}
          rows={rows}
        />
      ) : error ? (
        <Alert variant="error">
          {t("notifications.general.fetchError", {
            obj: t("finalizeCourse.assignmentResults"),
          })}
        </Alert>
      ) : selectedAssignmentId ? (
        <Alert>{t("finalizeCourse.noAssignmentResults")}</Alert>
      ) : (
        <Alert>{t("finalizeCourse.selectAnAssignment")}</Alert>
      )}
    </div>
  );
};

export default CanvasAssignment;
